import React from "react";
import { connect } from "react-redux";
import { fetchPdfReport } from "../../redux/pdf-report/pdf-report.actions";
import { createLoadingSelector } from "../../redux/loading/loading.selectors";
import { createErrorMessageSelector } from "../../redux/error/error.selectors";
import WithSpinner from "../with-spinner/with-spinner.component";
import validIcon from "../../images/valid-icon.svg";
import invalidIcon from "../../images/invalid-icon.svg";
import warningIcon from "../../images/warning-icon.svg";
import "./document-details.style.scss";


const errorSelector = createErrorMessageSelector(["FETCH_PDF_REPORT"]);
const loadingSelector = createLoadingSelector(["FETCH_PDF_REPORT"]);

const DocumentDetailsComponent = ({ validation, fetchPdfReport }) => {
  const { documentDetails, numOfSignatures, numOfValidSignatures, fileName } =
    validation;
  const downloadPdfReport = async () => {
    fetchPdfReport(validation);
  };

  const renderList = (list, title) => (
    <div className="signature-details__body">
      <p className="text-left">{title}</p>
      <div className="list-items">
        {list.length > 0
          ? list.map((item, key) => {
              return <p key={key}>{item}</p>;
            })
          : ""}
      </div>
    </div>
  );

  const renderDetails = (documentDetails) => {
    return documentDetails.map((document) => {
      const {
        signatureStatus,
        signatureId,
        signatureRef,
        signatureType,
        signatureFormat,
        signerName,
        signingTime,
        notAfter,
        signerCertificateChain,
        errors,
        warnings,
      } = document;

      let signatureStatusIcon = (
        <img className="invalid-icon" src={invalidIcon} alt="invalid-icon" />
      );

      if (!signatureStatus) return <div></div>;

      if (signatureStatus && signatureStatus.toUpperCase() === "INDETERMINATE")
        signatureStatusIcon = (
          <img className="warning-icon" src={warningIcon} alt="warning-icon" />
        );
      if (signatureStatus && signatureStatus.toUpperCase() === "VALID")
        signatureStatusIcon = (
          <img className="valid-icon" src={validIcon} alt="valid-icon" />
        );
      return (
        <div className="signature-details" key={signatureId}>
          <h3 className="signature-details__header">
            Potpis {signatureId} - {signatureRef}
          </h3>
          <div className="signature-details__body">
            <p className="text-left">Tip potpisa</p>
            <p className="text-right">{signatureType}</p>
          </div>
          <div className="signature-details__body">
            <p className="text-left">Format potpisa</p>
            <p className="text-right">{signatureFormat}</p>
          </div>
          <div className="signature-details__body">
            <p className="text-left">Status potpisa</p>
            <p className="text-right">
              {signatureStatusIcon} {signatureStatus.toUpperCase()}
            </p>
          </div>
          <div className="signature-details__body">
            <p className="text-left">Ime potpisnika</p>
            <p className="text-right">{signerName}</p>
          </div>
          <div className="signature-details__body">
            <p className="text-left">Vrijeme potpisa</p>
            <p className="text-right">{signingTime}</p>
          </div>
          <div className="signature-details__body">
            <p className="text-left">Datum isteka certifikata</p>
            <p className="text-right">{notAfter}</p>
          </div>

          {signerCertificateChain &&
            renderList(signerCertificateChain, "Lanac certifikata")}
          {errors && renderList(errors, "Greške")}
          {warnings && renderList(warnings, "Upozorenja")}
        </div>
      );
    });
  };

  if (numOfSignatures === 0) {
    return (
      <div className="details">
        <div className="details-header">
          <h2 className="details-title">Rezultati validacije</h2>
        </div>
        <div>
          <p className="lead">
            Naziv dokumenta: <span className="text">{fileName}</span>
          </p>
          <p className="detail-no-signature">Nema valjanih potpisa</p>
        </div>
        <div className="link-wrapper">
          <a href="/validacija" className="link-button">
            Napravi novu provjeru
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="details">
      <div className="details-header">
        <h2 className="details-title">Rezultati validacije</h2>
        <button className="download-report" onClick={downloadPdfReport}>
          Preuzmi izvještaj
        </button>
      </div>

      <hr />
      <div className="details-info">
        <p className="details-info__lead">
          Naziv dokumenta:{" "}
          <span className="details-info__text">{fileName}</span>
        </p>
        <p className="details-info__lead">
          Status:{" "}
          <span className="details-info__text">
            {numOfValidSignatures} od {numOfSignatures} valjana potpisa
          </span>
        </p>
      </div>

      {documentDetails ? renderDetails(documentDetails) : ""}
      <div className="link-wrapper">
        <a href="/validacija" className="link-button">
          Napravi novu provjeru
        </a>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
  error: errorSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchPdfReport: (params) => dispatch(fetchPdfReport(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithSpinner(DocumentDetailsComponent));
